import React, { useState } from "react";
import DeptIcon from "../../../../../Assets/Images/Department-icon.svg";
import MatchIndicator from "./MatchIndicator";
import PathIcon from "../../../../../Assets/Images/CandidateItemIcons/Path.svg";
import Hat from "../../../../../Assets/Images/CandidateItemIcons/Hat.svg";
import SkillsModal from "./SkillsModal";

const Candidate = (props) => {
  const [ModalIsOpen, setModalIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const displayName = () => {
    let FullName = props.Data.firstName + " " + props.Data.lastName;
    if (FullName.length === 0 || FullName === "null null") {
      return <h1></h1>;
    } else if (FullName.length <= 28) {
      return <h1>{FullName}</h1>;
    } else if (FullName.length > 28) {
      let Shortened = FullName.slice(0, 24) + " ...";
      return (
        <React.Fragment>
          <h1>
            <p className="popup-text">{FullName}</p>
            {Shortened}
          </h1>
        </React.Fragment>
      );
    }
  };
  const displayPosTitle = () => {
    let PosTitle = props.Data.currentPositionTitle;
    if (PosTitle === null || PosTitle.length === 0) {
      return <p></p>;
    } else if (PosTitle.length < 28) {
      return <p>{props.Data.currentPositionTitle}</p>;
    } else {
      let Shortened = PosTitle.slice(0, 23) + " ...";
      return (
        <React.Fragment>
          <p>
            {Shortened}
            <p className="popup-text">{PosTitle}</p>
          </p>
        </React.Fragment>
      );
    }
  };
  const swapPathNames = (Path) => {
    switch (Path) {
      case "career":
        return "Next level career";
      case "projects":
        return "Cool projects";
      case "skills":
        return "Improve skills";
      case "income":
        return "Improve income";
    }
  };

  const displaySkills = (Skills) => {
    return (
      <div className="skills-row">
        <span className="skill-item">
          {Skills[0].length < 20 ? Skills[0] : Skills[0].slice(0, 16) + " ..."}
        </span>
        <span
          className="skills-modal-trigger"
          onClick={() => setModalIsOpen(true)}
        >
          <i className="feather-more-horizontal"></i>
        </span>
      </div>
    );
  };

  const shortenText = (Text) => {
    if (Text.length > 20 && window.innerWidth >= 600 && window.innerWidth <=1024) {
      return Text.slice(0,17)+'...'
    }
    return Text
  }

  return (
    <div className="info-wrapper">
      {ModalIsOpen ? (
        <SkillsModal
          Close={() => setModalIsOpen(false)}
          Skills={props.Data.topSkills}
          Name={props.Data.firstName + " " + props.Data.lastName}
          PositionTitle={props.Data.currentPositionTitle}
          IsLang
        />
      ) : null}
      <section className="info-wrapper-head">
        <i className="feather-x" onClick={() => props.Close()}></i>
        <h1>{translateText("candidate_info")}</h1>
      </section>
      {props.Data === undefined ? null : (
        <div className="info-main-content">
          <div className="main-info mobile-main-info">
            {props.Data.imageThumbnailUrl === null ? (
              <span
                className="avatar-placeholder"
                style={{
                  background: props.Data.backgroundColorCode,
                  color: props.Data.textColorCode,
                }}
              >
                {props.Data.firstName.slice(0, 1).toUpperCase() +
                  props.Data.lastName.slice(0, 1).toUpperCase()}
              </span>
            ) : (
              <img alt="user" src={props.Data.imageThumbnailUrl} />
            )}
            <section className="user-info-grid">
              {displayName()}
              {displayPosTitle()}
            </section>
            <div className="indicator-wrapper">
              <MatchIndicator
                Percentage={parseInt(props.Data.similarity * 100)}
              />
            </div>
          </div>
          <div className="detailed-info">
            <section className="detailed-info-column">
              <h1 className="info-column-title">
                {translateText("candidate_details")}
              </h1>
              <div className="info-row">
                <img alt="" src={PathIcon} />
                <section className="row-info-grid">
                  <p className="row-info-title">
                    {translateText("wizard_your_path")}
                  </p>
                  {props.Data.path === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <span className="row-info-text path-items-wrapper">
                      {props.Data.path.split(",").map((Path) => (
                        <span className="path-item">{swapPathNames(Path)}</span>
                      ))}
                    </span>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-award"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">
                    {translateText("years_of_experience")}
                  </p>
                  {props.Data.yearsOfExperience === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">
                      {props.Data.yearsOfExperience}
                    </p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-globe"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">{translateText("language")}</p>
                  {props.Data.language === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">
                      {props.Data.language.map((Lang, i) => (
                        <React.Fragment>
                          {i > 0 && i + 1 < props.Data.language.length
                            ? Lang + ","
                            : Lang}
                        </React.Fragment>
                      ))}
                    </p>
                  )}
                </section>
              </div>
              <h1 className="info-column-title"></h1>
              <div className="info-row">
                <i className="feather-star"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">
                    {translateText("top_skills")}
                  </p>
                  {props.Data.topSkills === null ||
                  props.Data.topSkills.length === 0 ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <React.Fragment>
                      {displaySkills(props.Data.topSkills)}
                    </React.Fragment>
                  )}
                </section>
              </div>
              <div className="info-row">
                <img alt="" src={Hat} />
                <section className="row-info-grid">
                  <p className="row-info-title">
                    {translateText("higher_education")}
                  </p>
                  {props.Data.higherEducation === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">
                      {props.Data.higherEducation.degree}
                    </p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-map-pin"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">{translateText("home_city")}</p>
                  {props.Data.homeCity === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{props.Data.homeCity}</p>
                  )}
                </section>
              </div>
            </section>
          </div>
          <div className="detailed-info">
            <section className="detailed-info-column">
              <h1 className="info-column-title">
                {translateText("contact_info")}
              </h1>
              <div className="info-row">
                <i className="feather-mail"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">Email</p>
                  {props.Data.email === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{shortenText(props.Data.email)}</p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-smartphone"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">{translateText("mobile")}</p>
                  {props.Data.workMobile === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{props.Data.workMobile}</p>
                  )}
                </section>
              </div>
              <div className="info-row">
                <i className="feather-phone"></i>
                <section className="row-info-grid">
                  <p className="row-info-title">
                    {translateText("work_phone")}
                  </p>
                  {props.Data.workPhone === null ? (
                    <p className="not-available-text">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <p className="row-info-text">{props.Data.workPhone}</p>
                  )}
                </section>
              </div>
            </section>
          </div>
        </div>
      )}
    </div>
  );
};

export default Candidate;
